<template>
  <font-awesome-icon title="Повторная проверка" class="submit hover" @click="newAccess" icon="fa-solid fa-shield-halved" />
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'guard-button',
  props: ['id','model'],
  setup(props,{emit}) {
    const store = useStore()
    
    const security = {
      companies:{dadata_is_end:false,ati_is_end:false},
      drivers:{dadata_is_end:false,nalog_is_end:false},
      managers:{ati_is_end:false},
      cars:{avtocod_is_end:false,report_create:false},
    }
    
    const newAccess = async ()=>{
      const form = {id:props.id,security:security[props.model]}
      await store.dispatch('executors/updateSecure',{model:props.model,form})
      emit('reloadExecutor')
    }

    return {
      newAccess
    };
  },
};
</script>

<style scoped>

.submit{
  width: 30px;
  height: 30px;
  margin-right: 10px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 2px;
  border-radius: 5px;
  color: rgba(239,43,43,0.8);
}

.hover:hover{
  background-color: rgba(230,230,230, 1);
  cursor: pointer;
}
</style>
